module.exports = __webpack_public_path__ + "img/top_logo.cb9a3010.png";